import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import PortalVue from 'portal-vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from "vuelidate"
import coreMixin from "./mixins/CoreMixin"
import moment from 'moment'
import 'bootstrap'
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/styles.css'

Vue.use(PortalVue);
Vue.use(BootstrapVue);
Vue.use(require('vue-moment'), {
  moment
});
Vue.use(Vuelidate);

if (self===top) {
    new Vue({
        mixins: [coreMixin],
        router,
        store,
        render: h => h(App),
    }).$mount('#app');
}
